<template>
  <div :id="record.id">
    <div v-bind:class="!record.active ? 'close': ''">
      <div class="record-title width-full">
        <div class="float-left pt-2 mr-1">
          <span>
            <v-icon color="blue" size="18">chat</v-icon>
            <b class="text-blue ml-1">{{record.subtype}}</b>
          </span>
        </div>
        <div class="float-left" style="min-width:30px !important">
          <span @click="routeUser()" class="hover">
            <Avatar
              v-if="record.user.avatar != null"
              class="timeline-avatar"
              :src="`https://tradeinpool.com/upload/${record.user.avatar}.png`"
              :size="30"
            ></Avatar>
            <Avatar v-else class="timeline-avatar" :username="record.user.username" :size="30"></Avatar>
          </span>
        </div>
        <div class="float-left pt-2" style="margin-left: 33px;">
          <span class="text-grey">
            <span class="user-name">{{record.user.username}}</span>
            |
            {{openTime}}
          </span>
        </div>
        <div class="float-right">
          <MenuCard :record="record" /> 
        </div>
      </div>

      <div class="record-body width-full float-left mt-0 ml-1 mb-2">
        <div>
          <TextSlicer :text="record.data.message" :maxLength="200" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import VuePictureSwipe from "vue-picture-swipe";
import Avatar from "vue-avatar";
import MenuCard from "@/components/menuCard";
import TextSlicer from "@/components/textSlicer.vue";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar,
    MenuCard,
    TextSlicer
    //VuePictureSwipe
  },
  props: ["record"],
  data() {
    return {
      selected: false,
      dots: false,
      sliceTo: 200,
      moreText: "More",
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow(),
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  methods: {
    showMore() {
      if (this.moreText == "More") {
        this.sliceTo = this.record.data.message.length;
        this.moreText = "Less";
        this.dots = false;
      } else {
        this.sliceTo = 200;
        this.moreText = "More";
        this.dots = true;
      }
    },
    routeUser() {
      return this.$router.push({ path: "/user/" + this.record.user.username });
    }
  },
  filters: {},
  mounted() {
    if (this.record.data.message.length > 200) {
      this.dots = true;
    }

    // updating record time
    /*
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
    */
  },

  computed: {
    openTime() {
      var value = this.record.created;
      return moment.tz(value, this.$store.getters.timezone).format("HH:mm");
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}

.record-body {
  color: white;
  width: auto;
}
</style>
